import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalEnableSchoolGDPR from "root/s360components/Modals/EnableSchoolGDPR/ModalEnableSchoolGDPR";


const MODAL_EMPTY = {openState: false, school_id: null, school_name: null}

const useModalEnableSchoolGDPR = (refetchTable) =>
{
    const [dialog, setDialog]  = useState (MODAL_EMPTY)  ;

    const onClickActivate = ( school_id, school_name, GDPR_current_state ) =>
    {
        setDialog ({
            openState: true,
            school_id: school_id,
            school_name: school_name,
            GDPR_current_state: GDPR_current_state
        });
    }

    const onCloseModal = (submit = false) =>
    {
        setDialog (MODAL_EMPTY);

        if (submit === true)
        {
            refetchTable();
        }
    };


    const render = ( ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                < ModalEnableSchoolGDPR onClose={onCloseModal} school_id={dialog.school_id} school_name={dialog.school_name} GDPR_current_state={dialog.GDPR_current_state}/>
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalEnableSchoolGDPR;